export const getDeviceWidth = () => {
    return document.documentElement.clientWidth;
};

export const getDeviceHeight = () => {
    return document.documentElement.clientHeight;
};
